import {
  DELETE_EMAIL_TEMPLATE,
  GET_EMAIL_TEMPLATE,
  GET_EMAIL_TEMPLATES_LIST,
  POST_EMAIL_TEMPLATE,
  PUT_EMAIL_TEMPLATE,
  GET_EMAIL_CATEGORIES,
} from "../constants/actionTypes";

const defaultState = {
  emailTemplateArr: [],
  emailTemplate : {},
  emailCategories: []
};
let index = "";

export default (state = defaultState, action) => {
  try {
    switch (action.type) {
      case GET_EMAIL_TEMPLATES_LIST:
        return {...state,emailTemplateArr:[...action.payload]};
      case GET_EMAIL_TEMPLATE:
        return {...state,emailTemplate:{...action.payload}};
      case GET_EMAIL_CATEGORIES:
        return {...state,emailCategories:[...action.payload]};
      case POST_EMAIL_TEMPLATE:
        return {...state,emailTemplateArr:[...state?.emailTemplateArr, action.payload]};
      case PUT_EMAIL_TEMPLATE:
        const updatedTemplate = action.payload;
        const updatedTemplateArr = state?.emailTemplateArr?.map((item) =>
          item.id === updatedTemplate.id ? { ...item, ...updatedTemplate } : item
        );
        return { ...state, emailTemplate: { ...updatedTemplate }, emailTemplateArr: [...updatedTemplateArr] };
      case DELETE_EMAIL_TEMPLATE:
        const updatedArr = [...state].filter(
          (setting) => setting.id !== action.payload,
        );
        return [...updatedArr];
      default:
        return state;
    }
  } catch (error) {
    throw new Error(error);
  }
};
